import {getOganisationById, getTeamById, getCollectionDossierCount, getTeamTotalCount, inviteCount, inviteTeamMemberCount, checkStripeAccountStatus} from '@/libs/api/api'
import {getImageUrl, onError, getNewCount} from '@/libs/helper'
import {mapGetters} from 'vuex'
import {isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'OrgDetail',
    components: {
        donatePopup: () => import('@/components/component/Reuse/DonateDialog/DonateDialog.vue')
    },
    async mounted() {
        // fetch org deatils
        await this.fetchDetails()
        // intialise org
        this.intialiseOrganisation()
        // to check the donation account status
        // this.checkDonationAccountStatus()
    },
    data() {
        return {
            getNewCount,
            onError,
            getImageUrl,
            details: {},
            viewKey: 1,
            teamCount: 0,
            peopleCount: 0,
            dossiersCount: 0,
            collectionsCount: 0,
            articlesCount: 0,
            teamMemberCount: 0,
            showDonate: false,
            stripeAccountDetails: {},
            permissions: permissions
        }
    },
    computed: {
        ...mapGetters({
            selectedTeam: 'getTeam',
            organisationRoles: 'getOrganisationRoles',
            teamRoles: 'getTeamRoles',
            hasPermission: 'hasPermission'
        }),
        isTeams () {
            if (this.$route.name === pageRoute.teamOverview || this.$route.name === pageRoute.teamCollections || this.$route.name === pageRoute.teamCollectionPage || this.$route.name === pageRoute.teamMembers || this.$route.name === pageRoute.teamSettings || this.$route.name === pageRoute.teamDossiers || this.$route.name === pageRoute.teamDossierPage) {
                return true
            }
            else return false
        },
        toCallTeamsCount () {
            if (!this.isTeams && this.organisationRoles && this.organisationRoles.permissions && this.organisationRoles.permissions.includes(this.$getConst('TEAMS_TAB'))) return true
            return false
        }
    },
    watch: {
        isTeams () {
            this.intialiseOrganisation()
        },
        '$route' (to, from) {
            if (to.params.id !== from.params.id) {
                // fetch org deatils
                this.fetchDetails()
                // to check the donation account status
                // this.checkDonationAccountStatus()
                // intialise org
                this.intialiseOrganisation()
            }
        },
        toCallTeamsCount (value) {
            if (value) {
                this.getTeamCount()
            }
        }
    },
    methods: {
        /**
         * update the router key to route on the same route
         */
        updateViewKey () {
            this.viewKey +=1
        },

        /**
         *  to intialise organisation
         */
        intialiseOrganisation () {
            // if teams page then fetch team and count
            if (this.isTeams) {
                // set selected team
                this.setTeam()
                // get team counts
                this.getTeamsInternalCount()
            } else {
                // get org counts
                this.getOrganisationCount()
                // empty team selected in store
                this.$store.dispatch('setTeam', {})
                // empty permissions of team
                this.$store.dispatch('setTeamRoles', {})
            }
        },
        /**
         * to fetch the deatils of ORG
         */
        async fetchDetails () {
            try {
                let response = await getOganisationById(this.$route.params.id)
                this.details = response || {} 
            } catch (error) {
                console.error(error)
            }
        },

        /**
         * update form Data
         */
        updateFormDataValues (data) {
            this.details = data
        },

        /**
         * route to the teams page
         */
        routeToTeamsPage () {
            this.$router.push({name: 'org-teams', params: {id: this.$route.params.id}})
        },

        /**
         * to set the team data
         */
        async setTeam () {
            if (isEmpty(this.$store.getters.getTeam)) {
                let response = await getTeamById(this.$route.params.tid)
                this.$store.dispatch('setTeam', response)
            }   
        },

        /**
         * to fetch the count of teams
         */
        getTeamsInternalCount () {
            // collection count
            this.getCollectionCount()
            // dossier count
            this.getCollectionCount(true)
            // team members count
            this.getTeamMemberCount()
        },

        /**
         * to get the count of collections
         */
        getCollectionCount (isDossier) {
            // body for api
            let body = {
                entity_id: this.isTeams ? this.$route.params.tid :this.$route.params.id,
                entity_type: this.isTeams ? constants.ORGANISATIONS.TEAM : constants.ORGANISATIONS.ORGANISATION,
                count_for: isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION
            }
            // api call
            getCollectionDossierCount(body).then(response => {
                if (isDossier) this.dossiersCount = (response.count || 0)
                else this.collectionsCount = (response.count || 0)
            }).catch(error => error)
        },
        
        /**
         * to get total team count
         */
        async getTeamCount () {
            try {
                if (this.organisationRoles && this.organisationRoles.permissions && this.organisationRoles.permissions.includes(this.$getConst('TEAMS_TAB'))) {
                    let response = await getTeamTotalCount({organisation: this.$route.params.id})
                    this.teamCount = response.count || 0
                }
            } catch (error) {
                console.error(error)
            }
        },
        /**
         * to get the people count
         */
        getPeopleCount () {
            // api call
            inviteCount({organisation: this.$route.params.id}).then(response => {
                this.peopleCount = Object.values(response).reduce((a, b) => a+b, 0)
            }).catch(error => {
                console.error(error)
            })
        },

        /**
         * to get the team member internal count
         */
        getTeamMemberCount () {
            // api call
            inviteTeamMemberCount({team: this.$route.params.tid}).then(response => {
                this.teamMemberCount = Object.values(response).reduce((a, b) => a+b, 0)
            }).catch(error => {
                console.error(error)
            })
        },

        /**
         * to get all the count to show on 
         * Organisation home page
         */
        getOrganisationCount () {
            // people count
            this.getPeopleCount()
            // teams count
            this.getTeamCount()
            // collection count
            this.getCollectionCount()
            // dossier count
            this.getCollectionCount(true)
        },
        /**
         * to update the count
         */
        updateCount (type, count) {
            switch (type) {
                case constants.PEOPLE_LIST.PEOPLE: 
                    this.peopleCount = count
                break
                case constants.ORGANISATIONS.TEAM:
                    this.teamCount = count
                break
                case constants.PEOPLE_LIST.MEMBER:
                    this.teamMemberCount = count
                break
            }
        },

        /**
         * open donate popup
         */
        openDonatePopup () {
            this.showDonate = true
        },

        /**
         *  close donate popup
         */
        closeDonatePopup () {
            this.showDonate = false
        },

        /**
         * check eligiblity of an account status
         */
        checkDonationAccountStatus () {
            if(!this.hasPermission(permissions.checkAccountStatus)) return;
            // body for api
            let body = {
                entity_type: constants.ORGANISATIONS.ORGANISATION,
                entity_id: this.$route.params.id
            }
            // api call
            checkStripeAccountStatus(body).then(response => {
                this.stripeAccountDetails = response || {}
            })
        }
    }
}